import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let Sidemenu2Comp;

class Sidemenu extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: Sidemenu2Comp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(/* webpackChunkName: "components/javascript/sidemenu2-comp" */
        "../../../components/javascript/sidemenu2-comp").then(function(res) {
            Sidemenu2Comp = res.Sidemenu2Comp;
        }));

        
;
    }
}

export {Sidemenu};

